import { IOrderDTO } from '../services/order/types';

export type OrderAddress = IOrderDTO['customer']['addresses'][number];

/** `order.customer_address.address_type` FK value for a shipping address. */
export const SHIPPING_ADDRESS_TYPE = 1;

/**
 * Resolve the address an order actually ships to.
 *
 * A customer accumulates one profile address row (`order_id === null`) plus one
 * snapshot row per order (`order_id === <that order>`). Picking `addresses[0]`
 * or the first `address_type === 1` row shows the customer's *oldest* address,
 * which is wrong for any returning customer who shipped somewhere new — the
 * label is generated from the order-scoped snapshot, so the UI must match it.
 *
 * Resolution order:
 *   1. shipping snapshot for this order (what the label used)
 *   2. profile shipping address (`order_id === null`)
 *   3. any shipping address
 */
export function resolveOrderShippingAddress(order: IOrderDTO): OrderAddress | undefined {
    const addresses = order?.customer?.addresses ?? [];
    const shipping = addresses.filter((address) => address.address_type === SHIPPING_ADDRESS_TYPE);

    return (
        shipping.find((address) => address.order_id === order.id) ??
        shipping.find((address) => address.order_id === null || address.order_id === undefined) ??
        shipping[0]
    );
}
